import React, { useEffect, useState } from "react";
import { pubCall } from "../../utils/PubSub";
import { showError } from "../../ui/Message";
import VirtualTable from "../../ui/VirtualTable";
import { moveItem } from "../../utils/Utils";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import { ROUTES } from "../../utils/Routes";

export default function ISBNSearch(props) {

    const { controller = "", search = "", route = "", callback_on_single_result = false, callback = () => { } } = props;

    const [selected, setSelected] = useState({});
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [align, setAlign] = useState("auto");
    const row_key = "stock_id";

    useEffect(() => {

        pubCall("stock.searchIsbnStartingWith", { isbn: search }, (_s, _r) => {
            if (_s) {
                if(_r?.length === 1 && callback_on_single_result){
                    callback(_r[0]);
                    return; 
                }
                setResults(_r);
                if(_r?.length){
                    setSelected(_r[0])
                }
            } else {
                showError(_r);
            }
        })

    }, [])


    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: () => callback(false) },
            { key: KBD.ENTER, action: () => callback(selected) }
        ]
        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]);
        return cleanup;
    }, [selected])


    //  O/H  Title  Price  ISBN 
    const columns = [
        { min: true, width: 50, key: "total_onhand", align: "right", title: <>O/H</> },
        { min: true, width: 150, grow: true, align: "left", key: "title", title: <>Title</> },
        { min: true, width: 50, key: "price", align: "right", title: <>Price</> },
        { min: true, width: 170, key: "primary_code", align: "left", title: <>ISBN</> },
        { min: true, width: 25, key: "condition_code", align: "left", title: <>C</> },
    ];


    const move = (rows = 1) => {
        moveItem({ data: results, selected, setSelected, row_key, step: rows, setAlign, alignOnMove: true });
    }



    return (<>
        <div className="shim" /><div className="shim" />
        <VirtualTable
            row_height={26}
            controller={controller}
            onRowDoubleClick={(item) => {
                callback(item);
            }}
            onRowClick={(item, event, index) => {
                setSelected(item)
            }}
            next={(e) => move((e) ? e : 1)}
            prev={(e) => move((e) ? e * -1 : -1)}
            align={"auto"}
            row_key={row_key}
            current={selected}
            data={results}
            height={251}
            columns={columns}
            width={600}
            loading={loading}
            offset={430}
            route={route}

        />
    </>)
}